export default {
  bindings: {
    helptype: '@'
  },
  template: require('../views/help.area.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/base/components/help.area.component.js